<template>
	<BsModal v-model:show="data.show" style="z-index: 9999;">
		<template #header="{close}">
			<h5 class="modal-title">{{ data.header.title }}</h5>
			<button type="button" class="btn-close" aria-label="Close" @click="data.closeFunc(close)"></button>
		</template>
		<template #body="{close}">
			<div v-html="data.body.content"></div>
		</template>
		<template #footer="{close}">
			<button type="button" class="btn" :class="[data.footer.submitClass]" @click="data.submitFunc(close)" v-if="data.type != 'alert'">{{ data.footer.submit }}</button>
			<button type="button" class="btn" :class="[data.footer.closeClass]" @click="data.closeFunc(close)">{{ data.footer.close }}</button>
		</template>
	</BsModal>
	<!-- <div class="modal fade" tabindex="9999" id="WarningModal" style="z-index: 9999;">
		<div class="modal-dialog modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header" :class="[data.header.class]" v-if="data.header.show">
					<h5 class="modal-title">{{ data.header.title }}</h5>
					<button type="button" class="btn-close" aria-label="Close" @click="data.closeFunc(closeModal)"></button>
				</div>
				<div class="modal-body" :class="[data.body.class]">
					<p v-html="data.body.content"></p>
				</div>
				<div class="modal-footer" :class="[data.footer.class]" v-if="data.footer.show">
					<button type="button" class="btn" :class="[data.footer.submitClass]" @click="data.submitFunc(closeModal)" v-if="data.type != 'alert'">{{ data.footer.submit }}</button>
					<button type="button" class="btn" :class="[data.footer.closeClass]" @click="data.closeFunc(closeModal)">{{ data.footer.close }}</button>
				</div>
			</div>
		</div>
	</div> -->
</template>
<script setup>
	import usePub from "@/store/Public";
	const PubStore = usePub();

	const data = computed({
		get() {
			return PubStore.WarningModel;
		},
		set() {},
	});
</script>
